<template>
  <v-flex xs12 class="product-item">
    <promote-modal
      v-if="isShowPromoteModal"
      :item="album"
      :dismiss="dismissPromoteDialog"
      :success="saveAndFinish"
    />
    <v-flex sm12 product-content-section pa-0 relative>
      <router-link :to="'/album/' + album.slug">
        <div
          class="product-image"
          :style="{ 'background-image': 'url(' + album.cover.url + ')' }"
        ></div>
      </router-link>
      <v-layout wrap row class="product-content">
        <v-flex xs12 sm6 class="product-content-row" pr-0>
          <v-layout justify-space-around column fill-height>
            <h3>{{ album.name }}</h3>
            <div>{{ album.user.display_name }}</div>
          </v-layout>

          <!-- <label class="product-count product-status" v-if="album.stock_status=='active'">{{ album.stock_status }} <v-icon :class="album.stock_status">done</v-icon></label> -->
          <!-- <label class="product-count product-status" v-else>{{ album.stock_status }} <v-icon :class="album.stock_status">done</v-icon></label> -->

          <!-- <label class="product-count product-sold-count">Sold: <b>{{ album.sold }}</b></label> -->
          <!-- <label class="product-count product-stock-count">In Stock: <b>{{ album.stock }}</b></label> -->
        </v-flex>
        <!-- <v-flex sm12 class="product-content-row" pt-1>
          <label class="product-price">${{ album.price | formatNumber }}</label>

          <template v-if="$store.state.auth.user.id==album.merchant.id">
            <v-btn class="text-btn pr-1" @click.native.stop="deleteItem(product)">Delete</v-btn>
            <label class="btn-divider" v-if="showPromoteButton"></label>
            <v-btn class="text-btn" @click.native="editProduct()">Edit</v-btn>
            <label class="btn-divider"></label>
          </template>
          <template v-else>
            <v-btn class="text-btn" v-if="denyItem" @click.native="denyItem(product)">Deny</v-btn>
            <label class="btn-divider" v-if="denyItem"></label>
            <v-btn class="text-btn" v-if="acceptItem" @click.native="acceptItem(product)">Accept</v-btn>
            <label class="btn-divider" v-if="acceptItem"></label>
          </template>

          <label class="product-category-text" v-if="status && status != ''">{{ status }}</label>
          <label class="btn-divider" v-if="status && status != ''"></label>
          <label class="product-category-text">Category: {{ album.category ? album.category.name : '' }}</label>
        </v-flex> -->

        <v-flex
          xs12
          sm6
          class="product-content-row d-flex align-center justify-end gap-15"
        >
          <template v-if="album.collaborators_count === 0">
            <v-btn
              v-if="videoOnlyButtonAction"
              dark
              class="text-btn"
              @click.native="videoOnlyButtonAction(album)"
              >Make Live Video Only</v-btn
            >

            <v-select
              v-if="updateAccessLevelAction"
              :items="access_levels"
              v-model="album.access_level"
              item-text="title"
              item-value="id"
              placeholder="Select access level"
              class="pt-0 access-level"
              hide-details
              single-line
              @change="toggle_album_access_level_dialog = true"
            />

            <v-btn
              v-if="editButtonAction"
              dark
              class="text-btn text-poppins-15"
              @click.native="editProduct()"
            >
              Edit
            </v-btn>

            <v-btn
              v-if="deleteButtonAction"
              dark
              class="text-btn text-poppins-15"
              @click.native="show_album_delete_confirm_dialog = true"
            >
              Delete
            </v-btn>
          </template>

          <template v-else>
            <div class="w-100"></div>
            <span v-if="album.status == 'pending'" class="collaboration-status">
              <template
                v-if="
                  album.user.id === this.$store.state.auth.user.id &&
                  usersCountByStatus.accepted === album.collaborators_count
                "
              >
                <span class="approve-wrapper">
                  <!-- <span class="approved-text">
                    This album has been <br /><span>APPROVED</span>
                  </span> -->
                  <v-btn
                    dark
                    class="text-btn release text-poppins-15"
                    @click.native="releaseButtonAction(album)"
                  >
                    Release Now
                  </v-btn>
                </span>
              </template>

              <span v-else class="status-overview">
                <span v-if="usersCountByStatus.accepted > 0">
                  <span class="accepted-title">Accepted</span>
                  <span v-for="(c, i) in usersByStatus.accepted" :key="i">
                    {{ c.user.username }}
                  </span>
                </span>
                <span v-if="usersCountByStatus.denied > 0">
                  <span class="denied-title">Denied</span>
                  <!-- {{ usersByStatus.denied }} -->
                  <span v-for="(c, i) in usersByStatus.denied" :key="i">
                    {{ c.user.username }}
                  </span>
                </span>
                <span v-if="usersCountByStatus.pending > 0">
                  <span class="pending-title">Waiting for approval</span>
                  <span v-for="(c, i) in usersByStatus.pending" :key="i">
                    {{ c.user.username }}
                  </span>
                </span>
              </span>

              <span
                v-if="
                  acceptButtonAction &&
                  !usersByStatus.denied &&
                  !usersByStatus.accepted
                "
                class="collaboration-actions"
              >
                <v-btn
                  dark
                  class="text-btn deny text-poppins-15"
                  @click.native="denyButtonAction(album)"
                >
                  Deny
                </v-btn>
                <v-btn
                  dark
                  class="text-btn accept text-poppins-15"
                  @click.native="acceptButtonAction(album)"
                >
                  Accept
                </v-btn>
              </span>
            </span>
            <v-btn
              v-if="
                editButtonAction &&
                this.$store.state.auth.user.id === album.user.id
              "
              dark
              class="action-btn"
              @click.native="editButtonAction(album)"
              >Edit</v-btn
            >
            <v-btn
              v-if="
                deleteButtonAction &&
                this.$store.state.auth.user.id === album.user.id
              "
              dark
              class="text-btn text-poppins-15"
              @click.native="deleteButtonAction(album)"
              >Delete</v-btn
            >
            <!-- <span
              v-if="
                deleteButtonAction &&
                this.$store.state.auth.user.id === album.user.id
              "
            >
              <label class="btn-divider"></label>
              <label class="product-category-text"
                >{{ album.tracks.length }} tracks</label
              >
            </span> -->
          </template>
        </v-flex>
      </v-layout>
    </v-flex>

    <div
      v-if="album.status == 'collaborated' || album.status == 'pending'"
      class="divider"
    ></div>

    <v-flex
      v-if="album.status == 'collaborated' || album.status == 'pending'"
      sm12
      collaborator-content-section
    >
      <div>
        <div class="text-poppins-14">
          Collaborators ({{ usersByStatus.accepted.length }})
        </div>
        <div class="collaborator-content">
          <div
            v-for="(c, i) in usersByStatus.accepted"
            :key="i"
            class="collaborator-content__item"
          >
            <img
              :src="c.user.avatar.url"
              class="collaborator-content__item--img"
            />
            <div class="collaborator-content__item__user">
              <span class="username">
                {{ c.user.username }}
                <span
                  v-if="$store.state.auth.user.username === c.user.username"
                >
                  (owner)
                </span>
              </span>
              <span class="user-type">{{ c.user.user_type }}</span>
            </div>
          </div>

          <v-btn
            v-if="album.status == 'pending' && usersByStatus.denied > 0"
            depressed
            dark
            class="action-btn release"
            @click.native="releaseButtonAction(product)"
          >
            Release Now
          </v-btn>
        </div>
      </div>
    </v-flex>

    <v-dialog
      v-model="toggle_album_access_level_dialog"
      content-class="invite-dialog"
      width="440"
    >
      <v-card>
        <v-card-title class="headline"> Update Access Level </v-card-title>
        <v-card-text>
          Are you sure you want to update the access level?
        </v-card-text>
        <v-card-actions>
          <v-btn color="black" dark block @click.native="updateAccessLevel()"
            >Yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="show_video_only_confirm_dialog"
      content-class="invite-dialog"
      width="440"
    >
      <v-card>
        <v-card-title class="headline">
          Make an album available only for live
        </v-card-title>
        <v-card-text>
          If you click OK, the album will be available only for live video.
        </v-card-text>
        <v-card-actions>
          <v-btn color="black" dark block @click.native="videoOnlyAlbum()"
            >Yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="show_album_delete_confirm_dialog"
      content-class="invite-dialog"
      width="440"
    >
      <v-card>
        <v-card-title class="headline"> Delete Album </v-card-title>
        <v-card-text>
          If you click OK, your followers won't see the album any more. Click OK
          to delete &lt;{{ album.name }}&gt;
        </v-card-text>
        <v-card-actions>
          <v-btn color="red" dark block @click.native="deleteAlbum()"
            >Yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script type="text/javascript">
import _ from "lodash";
import promoteModal from "@/components/promotemodal";
import AlbumService from "@/services/album";
import UserService from "@/services/user";

export default {
  components: {
    promoteModal,
  },

  props: {
    textBtnToRight: {
      type: Boolean,
    },

    album: {
      type: Object,
    },

    type: {
      type: String,
    },

    editButtonAction: {
      type: Function,
    },

    publishButtonAction: {
      type: Function,
    },

    updateAccessLevelAction: {
      type: Function,
    },

    videoOnlyButtonAction: {
      type: Function,
    },

    deleteButtonAction: {
      type: Function,
    },

    acceptButtonAction: {
      type: Function,
    },

    denyButtonAction: {
      type: Function,
    },

    releaseButtonAction: {
      type: Function,
    },

    showPromoteButton: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      isShowPromoteModal: false,
      toggle_album_access_level_dialog: false,
      show_album_delete_confirm_dialog: false,
      show_video_only_confirm_dialog: false,
      loading: false,
      access_levels: [],
      access_level: this.album.access_level,
    };
  },

  computed: {
    usersCountByStatus() {
      console.log(_.countBy(this.album.collaborators, "status"));
      return _.countBy(this.album.collaborators, "status");
    },

    usersByStatus() {
      console.log(_.groupBy(this.album.collaborators, "status"));
      return _.groupBy(this.album.collaborators, "status");
    },
  },

  methods: {
    deleteAlbum() {
      this.loading = true;
      this.$store.dispatch("error/showLoadingActivity", true);
      AlbumService.deleteAlbum(this.album.id)
        .then((response) => {
          this.loading = false;
          this.$store.dispatch("error/showLoadingActivity", false);
          this.show_album_delete_confirm_dialog = false;
          this.reRenderManageAlbum();
          this.$store.dispatch("error/showSuccessToast", [
            "Album deleted successfully!",
          ]);
        })
        .catch((e) => {
          this.loading = false;
          this.$store.dispatch("error/showLoadingActivity", false);
          this.show_album_delete_confirm_dialog = false;
          this.$store.dispatch(
            "error/showErrorToast",
            e.body.errors || [e.body]
          );
        });
    },

    reRenderManageAlbum() {
      this.$emit("reRenderManageAlbum");
    },

    updateAccessLevel(album) {
      AlbumService.updateAccessLevel(this.album.id, {
        access_level: this.album.access_level,
      })
        .then((response) => {
          this.album.status = response.body.status;
          this.$store.dispatch("error/showSuccessToast", [
            "Access level updated successfully",
          ]);
          this.toggle_album_access_level_dialog = false;
        })
        .catch((e) => {
          this.toggle_album_access_level_dialog = false;
          this.$store.dispatch(
            "error/showErrorToast",
            e.body.errors || [e.body]
          );
        });
    },

    videoOnlyAlbum() {
      AlbumService.makeLiveVideoOnlyAlbum(this.album.id)
        .then((response) => {
          this.show_video_only_confirm_dialog = false;
          this.album.access_level = "published";
          this.album.status = "published";
          this.album.is_only_for_live_stream = true;
        })
        .catch((e) => {
          this.show_video_only_confirm_dialog = false;
          this.$store.dispatch(
            "error/showErrorToast",
            e.body.errors || [e.body]
          );
        });
    },
    editProduct() {
      this.$router.push({ path: `/album/${this.album.slug}/edit` });
    },
    showPromoteDialog() {
      this.isShowPromoteModal = true;
    },

    dismissPromoteDialog() {
      this.isShowPromoteModal = false;
    },

    saveAndFinish() {
      this.dismissPromoteDialog();
    },
  },

  mounted() {
    UserService.getAccessLevels(this.album.user.id).then((response) => {
      this.access_levels = response.body;
    });
  },
};
</script>

<style lang="scss" scoped>
.access-level {
  /deep/.material-icons {
    color: #000 !important;
  }
  /deep/[disabled] {
    background-color: #fff !important;
  }
}
</style>



// WEBPACK FOOTER //
// albumList.vue?0a0dec8a